//src/services/orders.api.js
import { apiRequest } from "./api";

export const getMyOrders = () => {
  return apiRequest("/orders/my");
};